import { render, staticRenderFns } from "./children.vue?vue&type=template&id=a284a742&scoped=true"
import script from "./children.vue?vue&type=script&lang=js"
export * from "./children.vue?vue&type=script&lang=js"
import style0 from "./children.vue?vue&type=style&index=0&id=a284a742&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a284a742",
  null
  
)

export default component.exports